import { Platform } from "react-native";
import Color from "../../assets/color/Color";
import StyleSheet from "react-native-media-query";
import { theme } from "../../theme/theme";
export const { ids, styles } = StyleSheet.create({
  backButton: {
    padding: 10,
    marginRight: 10,
  },
  backIcon: {
    width: 24,
    height: 24,
  },
  titleContainer: {
    flex: 1,
    justifyContent: "center",
  },
  screenTitle: {
    fontSize: 18,
    fontWeight: "600",
    color: "#000", // Adjust color as needed
  },
  newNotification: {
    backgroundColor: theme.colors.primary,
    width: 9,
    height: 9,
    borderRadius: 10,
    display: "flex",
    position: "absolute",
    top: 0,
    left: 12,
    borderWidth: 1,
    borderColor: theme.colors.white,
  },
  bellIcon: {
    width: 20.9,
    height: 24,
    position: "relative",
    top: 1,
  },
  navigationBar: {
    zIndex: 199,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: theme.colors.grayLighter,
    width: "100%",
    height: 70,
    overflow: "hidden",
    ...Platform.select({
      ios: {
        paddingTop: 5,
        height: 95,
      },
    }),
  },
  navActiveDocs: {
    backgroundColor: theme.colors.primary,
    borderRadius: 5,
    width: 20,
    height: 4,
    marginTop: 3,
    fontWeight: "600",
  },
  activeDocs: {
    color: theme.colors.primary,

    ...Platform.select({
      ios: {
        fontWeight: "600",
      },
      android: {
        fontWeight: "700",
      },
      web: {
        "@media (min-width: 700px)": {
          fontSize: 11,
        },
        "@media (min-width: 1150px)": {
          fontSize: 13,
        },
        "@media (min-width: 1281px)": {
          fontSize: 14,
        },
        "@media (min-width: 1441px)": {
          fontSize: 16,
        },
        "@media (min-width: 1681px)": {
          fontSize: 18,
        },
      },
    }),
  },
  navActiveAgent: {
    backgroundColor: theme.colors.text.secondary,
    borderRadius: 5,
    width: 20,
    height: 4,
    marginTop: 3,
    fontWeight: "600",
  },
  activeAgent: {
    color: theme.colors.text.secondary,

    ...Platform.select({
      ios: {
        fontWeight: "600",
      },
      android: {
        fontWeight: "700",
      },
      web: {
        "@media (min-width: 700px)": {
          fontSize: 11,
        },
        "@media (min-width: 1150px)": {
          fontSize: 13,
        },
        "@media (min-width: 1281px)": {
          fontSize: 14,
        },
        "@media (min-width: 1441px)": {
          fontSize: 16,
        },
        "@media (min-width: 1681px)": {
          fontSize: 18,
        },
      },
    }),
  },
  navActiveClaim: {
    backgroundColor: theme.colors.secondary,
    borderRadius: 5,
    width: 20,
    height: 4,
    marginTop: 3,
  },
  activeClaim: {
    color: theme.colors.secondary,
    ...Platform.select({
      ios: {
        fontWeight: "600",
      },
      android: {
        fontWeight: "700",
      },
      web: {
        "@media (min-width: 700px)": {
          fontSize: 11,
        },
        "@media (min-width: 1150px)": {
          fontSize: 13,
        },
        "@media (min-width: 1281px)": {
          fontSize: 14,
        },
        "@media (min-width: 1441px)": {
          fontSize: 16,
        },
        "@media (min-width: 1681px)": {
          fontSize: 18,
        },
      },
    }),
  },
  bgEffect: {
    backgroundColor: theme.colors.white,
    position: "absolute",
    top: -527,
    left: -200,
    ...Platform.select({
      ios: {
        "@media (min-width: 385px)": {
          // for low resolution iPad
          top: -527,
          left: -202,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 700px)": {
          // for low resolution iPad
          top: -527,
          left: 53,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 1050px)": {
          // for hight resolution iPad
        },
      },
      android: {
        "@media (min-width: 200px)": {
          // Android small devices
          left: -100,
          top: 70,
        },
        "@media (min-width: 385px)": {
          // Android large devices
          top: -527,
          left: -202,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 485px)": {
          // Android small tablet
          top: -527,
          left: -202,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 700px)": {
          // Android medium (Galaxy S4) tablet
          top: -527,
          left: 55,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 900px)": {
          // Android large tablet
          top: -527,
          left: 52,
          backgroundColor: theme.colors.white,
        },
      },
      web: {
        "@media (min-width: 700px)": {
          top: -527,
          left: 54,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 1281px)": {
          top: -527,
          left: 54,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 1441px)": {
          top: -527,
          left: 54,
          backgroundColor: theme.colors.white,
        },
        "@media (min-width: 1681px)": {
          top: -527,
          left: 54,
          backgroundColor: theme.colors.white,
        },
      },
    }),
    transform: [{ rotate: "45deg" }],
    width: 400,
    height: 1000,
  },
  navContainer: {
    maxWidth: "100%",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          top: 20,
          maxWidth: "100%",
          justifyContent: "flex-start",
        },
      },
      android: {
        top: 0,
        maxWidth: "100%",
        justifyContent: "flex-start",
      },
      web: {
        "@media (min-width: 700px)": {
          maxWidth: 1180,
          width: "100%",
        },
        "@media (max-width: 700px)": {
          maxWidth: 1180,
          width: "100%",
        },
      },
    }),
  },
  navContainerPolicyAction: {
    maxWidth: "100%",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          top: 20,
          maxWidth: "100%",
          justifyContent: "flex-start",
        },
      },
      android: {
        top: 0,
        maxWidth: "100%",
        justifyContent: "flex-start",
      },
      web: {
        "@media (min-width: 700px)": {
          width: "100%",
        },
        "@media (max-width: 700px)": {
          width: "100%",
        },
      },
    }),
  },
  navContainerPdf: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          justifyContent: "space-between",
        },
      },
      android: {
        justifyContent: "space-between",
      },
      web: {
        "@media (min-width: 700px)": {},
      },
    }),
  },
  mainLink: {
    ...Platform.select({
      ios: {
        "@media (min-width: 600px)": {
          width: "62%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        },
        "@media (min-width: 840px)": {
          minWidth: "73%",
        },
      },
      android: {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "center",
        position: "relative",
        paddingRight: 180,
        "@media (min-width: 500px)": {
          paddingLeft: 24,
        },
        "@media (min-width: 600px)": {
          paddingLeft: 24,
        },
        "@media (min-width: 1000px)": {
          paddingLeft: 36,
        },
      },
      web: {
        alignItems: "center",
        justifyContent: "center",
        "@media (min-width: 100px)": {
          transform: [{ scale: 0 }],
        },
        "@media (min-width: 700px)": {
          transform: [{ scale: 1 }],
          width: "auto",
          flex: 1,
        },
        "@media (max-width: 700px)": {
          height: 0,
          overflow: "hidden",
        },
      },
    }),
  },
  navList: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    flex: 1,
    width: "75%",
    ...Platform.select({
      ios: {},
      android: {},
      web: {
        "@media (min-width: 100px)": {
          transform: [{ scale: 0 }],
        },
        "@media (min-width: 700px)": {
          transform: [{ scale: 1 }],
        },
      },
    }),
  },
  navRightIcon: {
    ...Platform.select({
      ios: {
        position: "absolute",
        right: 0,
      },
      android: {
        position: "absolute",
        right: 0,
      },
      web: {},
    }),
  },
  navRight: {
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingRight: 16,
        },
        "@media (min-width: 700px)": {
          paddingRight: 36,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingRight: 16,
        },
        "@media (min-width: 700px)": {
          paddingRight: 36,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          paddingRight: 16,
        },
        "@media (min-width: 700px)": {
          paddingRight: 36,
        },
      },
    }),
  },
  navCenter: {
    paddingRight: 16,
  },
  marginLeft: {
    marginLeft: 12,
  },
  leftText: {
    color: theme.colors.text.secondary,
  },
  navLeft: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    // paddingLeft: 12,
    ...Platform.select({
      ios: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 700px)": {
          paddingLeft: 24,
        },
      },
      android: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 700px)": {
          paddingLeft: 24,
        },
      },
      web: {
        "@media (min-width: 200px)": {
          paddingLeft: 0,
        },
        "@media (min-width: 700px)": {
          paddingLeft: 24,
        },
      },
    }),
  },
  navLogoText: {
    textAlign: "center",
    fontSize: 18,
    fontWeight: "bold",
    color: theme.colors.text.secondary,
  },
  navDisplayText: {
    textAlign: "center",
    fontSize: 14,
    width: "80%",

    color: "#000",
  },
  navText: {
    fontFamily: theme.fontFamily.robotoSlabBold,
    color: theme.colors.text.secondary,

    ...Platform.select({
      ios: {
        fontWeight: "500",
        fontSize: theme.fontsize.mmd,
      },
      android: {
        fontWeight: "500",
        fontSize: theme.fontsize.mmd,
      },
      web: {
        fontWeight: theme.fontweight.bold,
        "@media (min-width: 700px)": {
          fontSize: theme.fontsize.sm,
        },
        "@media (min-width: 1150px)": {
          fontSize: theme.fontsize.reg,
        },
        "@media (min-width: 1281px)": {
          fontSize: theme.fontsize.cs,
        },
        "@media (min-width: 1441px)": {
          fontSize: theme.fontsize.md,
        },
        "@media (min-width: 1681px)": {
          fontSize: theme.fontsize.mmd,
        },
      },
    }),
    alignItems: "flex-end",
  },
  LogoCover: {
    width: 120,
    height: 45,
    maxHeight: 55,
    // flex: 1,
    resizeMode: "contain", // or 'stretch',
    justifyContent: "flex-start",
    "@media (min-width: 700px)": {
      width: 130,
      height: 40,
      maxHeight: 105,
      justifyContent: "flex-start",
      // flex: 1,
      resizeMode: "contain", // or 'stretch'
    },
  },
  Logo: {
    width: "100%",
    height: "100%",
    display: "flex",
    resizeMode: "contain",
  },
  Hamburger: {
    width: 20,
    height: 20,
  },
  Profile: {
    width: 24,
    height: 24,
  },
  Back: {
    width: 12,
    height: 20,
    display: "flex",
  },
  BackArea: {
    width: 44,
    height: 44,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  user: {
    width: 18,
    height: 18,
    borderWidth: 0,
    position: "relative",
    top: 10,
    opacity: 1,
    cursor: "pointer",
  },
  deleteCross: {
    width: 18,
    height: 18,
  },
});
